/**
* This file contains jQuery methods specific to Origin. These are smaller functions 
* tied to the UI. (Also see jquery.utility.js)
*/

(function ($) {
	// this method initializes any loaded smooth-forms
	$.fn.smoothForm = function () {
		if ($(this)[0].tagName.toLowerCase() == 'body' && !$(this).hasClass('smooth-form'))
			$(this).addClass('smooth-form');

		$(this)
			.find('input:text, input:password, textarea, select').not('.not-smooth-form, .ignore-smooth-form')
				.each(function () {
				    if (!$(this).parents('.not-smooth-form, .ignore-smooth-form').length) {
				        var className = $(this).is('textarea') ? 'textarea' : 'input';

				        if ($(this).closest('.' + className).length == 0) {
				            $(this).wrap('<div class="' + className + '"/>').wrap('<span/>').wrap('<span/>');

				            if ($(this).attr('id')) {
				                $('label[for="' + $(this).attr('id') + '"]').not('.ignore-smooth-form').addClass('smooth-label');
				            }
				        }
				    }
				});
		return $(this);
	};

	// This method takes an element and converts it to a jquery ui button. Optionally, a
	// click function can be defined to execute when click if not using onAction
	$.fn.originButton = function (options) {
		var defaults = {
			click: $.noop
		};
		var settings = $.extend({}, defaults, options);

		return $(this).each(function () {
			var data = $(this).dataset();

			if (data) {
				$(this)
					.button({
						icons: {
							primary: data.primaryIcon || '',
							secondary: data.secondaryIcon || ''
						}
					})
					.css({ visibility: 'visible' });
			} else {
				$(this)
					.button()
					.css({ visibility: 'visible' });
			}

			if (settings.click) {
				$(this).click(function () {
					settings.click.call();
				});
			}
		});
	};

	// This method takes an element and converts it to a jquery ui buttonset.
	$.fn.originButtonset = function () {
		return $(this).each(function () {
			$(this).buttonset();
		});
	};


	// This method sets up the type ahead or auto complete component
	$.fn.originTypeAheadCity = function (options) {
		return this.autocomplete(
			options.url,
			{ dataType: 'json',
				formatItem: function (data, i, max, value, term) {
					return value;
				},
				parse: function (data) {
					return $.map(data, function (d, i) {
						return { data: d, value: d, result: d };
					});
				}
			});
	};

	// This is refactored to origin.js: Origin.onAction('help'
	$.fn.originShowHelp = function () {
		return this.each(function () {
			$(this).click(function () {
				var url = $(this).attr('href') || $(this).attr('data-help');
				// TODO: Check for case where there is inline content
				Origin.showHelp({ url: url });
				return false;
			});
		});
	};

	//	$.fn.showContentLoading = function(options) {
	//		var defaults = { collapse: false, size: 'medium' };
	//		var settings = $.extend({}, defaults, options);

	//		return this.each(function() {
	//			var thisWidth = $(this).innerWidth();
	//			var thisHeight = $(this).innerHeight();
	//			var element = $('<div class="loading-' + settings.size + '"></div>');

	//			if (settings.collapse) {
	//				$(this)
	//					.html('')
	//					.append(element);
	//			} else {
	//				element
	//					.html('')
	//					.css({
	//						'height': thisHeight,
	//						'width': thisWidth
	//					})
	//					.attr('data-size', settings.size)
	//					.appendTo($(this));
	//			}
	//		});
	//	};

	//	$.fn.hideContentLoading = function(options) {
	//		var defaults = {};
	//		var settings = $.extend({}, defaults, options);

	//		return $(this).each(function() {
	//			$(this)
	//				.find('.loading-' + $(this).attr('data-size'))
	//				.remove();
	//		});
	//	};

	$.fn.showContentLoading = function (size, overlay) {
		var sizes = {
			small: 'small',
			medium: 'medium',
			large: 'large',
			none: 'none'
		};
		var loading = $('<div class="origin-loading"><img src="/Themes/Default/Content/Images/transparent.gif" class="loading-'
						+ (sizes[size] || 'small') + '" /></div>');
		return this.each(function () {

			if ($(this).hasClass('sfdcBody')) {
				return;
			}

			var over = loading.clone();

			var _element = this;
			var target = $(this).closest('.ui-dialog-content').filter(':visible');
		    var scrollTop = 0;
		    if (target.length > 0) {
		        scrollTop = $(target).scrollTop();
		    } else {
		        target = "body";
		    }
			over.bind('size', function () {
				$(this)
						.css({
							width: $(_element).outerWidth(),
							height: $(_element).outerHeight()
						})
						.positionBy({
							target: _element,
							force: true,
							targetPos: 0,
							elementPos: 0
						});
				$(this).css('top', (parseInt($(this).css('top'), 10) + scrollTop) + 'px');
			})
				.appendTo(target)
				.trigger('size');

		    var existingLoadingElement = $(this).data('loadingElement') || null;
		    if (existingLoadingElement) {
		        $(this).removeData('loadingElement');
		        $(existingLoadingElement).remove();
		    }

			$(this).data('loadingElement', over[0]);
		});
	};

    $.fn.hideContentLoading = function() {
        return this.each(function () {
            var element = $(this);
            var loading = element.data('loadingElement') || null;
            if (loading) {
                $(loading).fadeOut('fast', function () {
                    element.removeData('loadingElement');
                    $(this).remove();
                });
            }
        });
    };

    $.fn.forceHideContentLoading = function () {

    	$('div.origin-loading', this).each(function () {
		    $(this).fadeOut('fast', function () {
		        $(this).remove();
		    });
		});
	};

	$(window).bind('resize', function () {
		$('div.origin-loading').trigger('size');
	});
	$.fn.addInlineLoading = function (txt) {
		return this.html('<img src="/Themes/Default/Content/Images/transparent.gif" class="loading-small" />' + (txt ? ' ' + txt : ''));
	};

	$.fn.originButtonLabel = function (label) {
		if (arguments.length == 0) {
			return $('> span > span', this).html();
		}
		return this.each(function () {
			$('> span > span', this).html(label);
		});
	};

	$.fn.navigate = function () {
		var url = $(this).dataset().url;
		if (url)
			Origin.redirect(url);
		else
			return false;
	};

	$.fn.error = function (elementId, msg) {
		if (arguments.length == 1) {
			msg = arguments[0];
		}

		$('ul.error-summary').append('<li>' + msg + '</li>')
	};

	// This method changes the focus to the element on which forceFocus is called.
	$.fn.forceFocus = function () {
		var _input = this;

		// For IE focus must be set twice to actually get focus (not a timing issue - increasing the timeout does not fix this)
		setTimeout(function () {
			$(_input).autoFocus();
		}, 90);

		setTimeout(function () {
			$(_input).autoFocus();
		}, 100);
	};
})(jQuery);